module.exports = __webpack_public_path__ + "img/blog-4.cb46ccd9.webp";